import { render, staticRenderFns } from "./Imprint.vue?vue&type=template&id=b53b5db4&scoped=true&lang=pug&"
import script from "./Imprint.vue?vue&type=script&lang=ts&"
export * from "./Imprint.vue?vue&type=script&lang=ts&"
import style0 from "./Imprint.vue?vue&type=style&index=0&id=b53b5db4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53b5db4",
  null
  
)

export default component.exports